/**
 * Base URL para los clientes que llaman a la propia app (Hono RPC y el cliente
 * de Better Auth).
 *
 * Reglas:
 * - Si `NEXT_PUBLIC_API_URL` está definida (staging/prod, o un override
 *   por-worktree), se usa tal cual → comportamiento absoluto de siempre.
 * - Si está vacía/ausente (convención de DEV = same-origin) y estamos en el
 *   browser, se usa el origin actual (`window.location.origin`). Así un worktree
 *   corriendo en cualquier puerto (3000, 3005, …) hace fetch a sí mismo sin CORS.
 * - En el server sin origin disponible (SSR, route handlers) se cae a
 *   `http://localhost:3000`, que es el puerto por defecto del checkout principal.
 *   Los worktrees en otro puerto reescriben `NEXT_PUBLIC_API_URL` en su
 *   `.env.local` (ver skill `worktree`), por lo que entran por la primera regla.
 *
 * Nota: `process.env.NEXT_PUBLIC_API_URL` se inlinea en build para los bundles
 * de cliente, así que el guard `typeof window` resuelve correctamente en cada
 * entorno.
 */
export const getClientBaseURL = (): string => {
  const fromEnv = process.env.NEXT_PUBLIC_API_URL;
  if (fromEnv) return fromEnv;
  if (typeof window !== "undefined") return window.location.origin;
  return "http://localhost:3002";
};